import React from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Page } from '@adobe/aem-react-editable-components';
import { setView360State } from '@yme/pdp-components/ProductCard';
import { DigitalDataMutation, interceptExternalRedirect, setDigitalData } from '@yme/utils/common';
import { setPageProperties as setPagePropertiesAction } from '../../common/redux/common/action';
import { requestAPI } from '../../utils/api';
import { setProductCardInitialState } from './redux/actions';
class ProductDetailsPage extends Page {
    get containerProps() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const attrs = super.containerProps;
        attrs.className = `${attrs.className || ''} page ${this.props.cssClassNames || ''}`;
        return attrs;
    }
    componentDidMount() {
        const { hyperdriveEndpoint, isRightToLeft, daysToShowNew, isShowDriverLicenseEnabled, isInAuthor, currentCountryRoot, currentLanguageRoot, commercetoolsProjectKey, setPageProperties, language, isFinanceCalculatorEnabled, instantFinanceQuoteLink, financeCalculatorPluginSourcePath, financeCalculatorLeadFormPagePath, labels = {}, ecommerceEnabled, isInstallmentEnabled, isCycleSchemeEnabled, isNavDarkModeEnabled, isTestRideEnabled, ecommerceId, languageRootPath, cqType, externalCart, pageLevelNavigation, locale, brandSlug, categoryTitle, title, isoCountryCode, locationMismatchModalModel, configuratorLeadFormPagePath, outboardEnginesSelectionLink, dealerLocatorPageUrl, isNewsletterSubscriptionEnabled, isSearchEnabled, isMotorcycleVariationsEnabled, bloomreachModel, searchResultsPageUrl, isKioskVersion, isOmnibusRegulationEnabled, isNavLoggedInIndicatorEnabled, is70thLogoEnabled, isVisualWebsiteOptimizerEnabled, anniversary70thLogoPagePath, isCurrencyConverterEnabled, } = this.props;
        setPageProperties({
            isCurrencyConverterEnabled,
            isFinanceCalculatorEnabled,
            financeCalculatorPluginSourcePath,
            instantFinanceQuoteLink,
            isRightToLeft,
            daysToShowNew,
            isShowDriverLicenseEnabled,
            anniversary70thLogoPagePath,
            dealerLocatorPageUrl,
            isInAuthor,
            currentCountryRoot,
            financeCalculatorLeadFormPagePath,
            currentLanguageRoot,
            commercetoolsProjectKey,
            language,
            labels,
            ecommerceEnabled,
            isInstallmentEnabled,
            isCycleSchemeEnabled,
            isNavDarkModeEnabled,
            isTestRideEnabled,
            ecommerceId,
            languageRootPath,
            pageType: cqType,
            externalCart,
            pageLevelNavigation,
            locale,
            configuratorLeadFormPagePath,
            brandSlug,
            categoryTitle,
            title,
            isOmnibusRegulationEnabled,
            isoCountryCode,
            locationMismatchModalModel,
            outboardEnginesSelectionLink,
            isNewsletterSubscriptionEnabled,
            isSearchEnabled,
            isMotorcycleVariationsEnabled,
            bloomreachModel,
            searchResultsPageUrl,
            isKioskVersion,
            isNavLoggedInIndicatorEnabled,
            is70thLogoEnabled,
            isVisualWebsiteOptimizerEnabled,
        });
        // Push the custom data layer
        setDigitalData(DigitalDataMutation.CP_VIEW, this.props.webData);
        // TODO: change approach for action type naming.
        if (hyperdriveEndpoint) {
            this.props.requestAPI({
                url: hyperdriveEndpoint,
                actionType: 'GET_PRODUCT_CARD',
            });
        }
    }
    componentWillUnmount() {
        this.props.setProductCardInitialState();
        this.props.setView360State(false);
    }
    // @ts-expect-error null return in case of redirect
    render() {
        const redirectUrl = this.props.redirectTargetUrl;
        if (interceptExternalRedirect(redirectUrl)) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            redirectUrl && React.createElement(Redirect, { to: redirectUrl }),
            React.createElement(Helmet, null,
                React.createElement("link", { rel: "canonical", href: this.props?.canonical, "data-react-helmet": "true" }),
                React.createElement("meta", { name: "template", content: this.props?.templateName, "data-react-helmet": "true" })),
            this.childComponents,
            this.childPages));
    }
}
export default connect(null, {
    requestAPI,
    setPageProperties: setPagePropertiesAction,
    setProductCardInitialState,
    setView360State,
})(ProductDetailsPage);
